// Cookie Management Utility
export class CookieManager {
  static getConsentStatus() {
    return localStorage.getItem('cookieConsent');
  }

  static getPreferences() {
    const preferences = localStorage.getItem('cookiePreferences');
    return preferences ? JSON.parse(preferences) : {
      necessary: true,
      analytics: false,
      marketing: false,
      functional: false
    };
  }

  static hasConsent() {
    return this.getConsentStatus() !== null;
  }

  static canUseAnalytics() {
    const preferences = this.getPreferences();
    return preferences.analytics;
  }

  static canUseMarketing() {
    const preferences = this.getPreferences();
    return preferences.marketing;
  }

  static canUseFunctional() {
    const preferences = this.getPreferences();
    return preferences.functional;
  }

  static clearConsent() {
    localStorage.removeItem('cookieConsent');
    localStorage.removeItem('cookiePreferences');
  }

  // Initialize Google Analytics if consent is given
  static initializeAnalytics() {
    if (this.canUseAnalytics()) {
      // Add your Google Analytics initialization code here
      console.log('Analytics initialized');
      
      // Example Google Analytics 4 initialization:
      // gtag('config', 'GA_MEASUREMENT_ID', {
      //   page_title: document.title,
      //   page_location: window.location.href,
      // });
    }
  }

  // Initialize marketing tools if consent is given
  static initializeMarketing() {
    if (this.canUseMarketing()) {
      console.log('Marketing tools initialized');
      
      // Add your marketing tools initialization here
      // Example: Facebook Pixel, Google Ads, etc.
    }
  }

  // Initialize functional services if consent is given
  static initializeFunctional() {
    if (this.canUseFunctional()) {
      console.log('Functional services initialized');
      
      // Add your functional services initialization here
      // Example: Chat widgets, personalization features, etc.
    }
  }

  // Initialize all services based on current preferences
  static initializeAllServices() {
    this.initializeAnalytics();
    this.initializeMarketing();
    this.initializeFunctional();
  }
}

// Export individual functions for convenience
export const {
  getConsentStatus,
  getPreferences,
  hasConsent,
  canUseAnalytics,
  canUseMarketing,
  canUseFunctional,
  clearConsent,
  initializeAnalytics,
  initializeMarketing,
  initializeFunctional,
  initializeAllServices
} = CookieManager;
